// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"c9cd15d4","776":"019697af","808":"89960b73","827":"58c4bbba"}[chunkId] + ".chunk.css";
};